( ( $, helper ) => {

	if ( helper && helper.register ) {
		helper.register( 'product-recommendations',
			{
				onLoad() {
					console.log( 'Recommendation Load' );
					this.$container = $( '.product-recommendations' );
					const $container = this.$container;
					const baseUrl = $container.data( 'baseUrl' );
					const productId = $container.data( 'productId' );
					const limit = $container.data( 'limit' );
					const productRecommendationsUrlAndContainerClass = `${ baseUrl }?section_id=product-recommendations&limit=${ limit }&product_id=${ productId } .product-recommendations`;

					$container.parent().load( productRecommendationsUrlAndContainerClass, () => {
						$( document ).trigger( 'wpshopify.block_loaded', [ $( '.product-recommendations' ).get( 0 ) ] );
					} );
				},
			} );
		// when section is registered, lets load it.
		if ( helper.load ) {
			helper.load( 'product-recommendations' );
		}
	}

} )( jQuery, window.MLShopifySectionHelper )
